import { trackPromise } from 'react-promise-tracker';
import { t } from 'i18next';

import axiosInstance from '../axios';
import {
  GET_SUBSCRIPTION_PLANS,
  SET_SNACKBAR_ERROR,
  SET_SNACKBAR_SUCCESS,
  SUBSCRIPTION_SUCCESS,
  UPDATE_URL_RETRIEVED,
  ADD_ON_PURCHASED,
  LOADER,
  GET_ALL_PRICES_DE,
  GET_BILLING_DETAILS,
  GET_SUBSCRIPTION_STATUS,
} from './types';
import { getBackendHost } from '../utils/urls';
import { splitBillingDetails, splitingBillingHistory } from '../utils/helpers';
import { getDeployRegion } from '../utils/configurationHelpers';
import { GERMANY } from '../constants/constants';
import { RETINOSCAN_PLANS } from '../constants/subscriptions';

// export const connectWebSocketSubscription = (id) => (dispatch) => {
//   let websocketProtocol = 'ws';
//   if (window.location.protocol === 'https:') websocketProtocol = 'wss';
//   const ws = new WebSocket(websocketProtocol + `://${getBackendHost()}/ws/payments/stripe/${id}/`);

//   ws.onmessage = (evt) => {
//     // listen to data sent from the websocket server
//     const result = JSON.parse(evt.data);
//     if (result?.subscription_status) {
//       dispatch({
//         type: GET_SUBSCRIPTION_STATUS,
//         payload: result.subscription_status,
//       });
//     }
//   };
// };
export const getPlansForSubscription = (retinoscan_plan) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(`/payments/plans/${retinoscan_plan}/subscription/list/`)
      .then((result) => {
        if (getDeployRegion() === GERMANY) {
          dispatch({
            type: GET_ALL_PRICES_DE,
            payload: result.data,
          });
        }
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getPlansForPrepaid = (retinoscan_plan) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(`/payments/plans/${retinoscan_plan}/prepaid/list/`)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const purchasePlan = (id, lang) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(`/payments/payment/continue/`, {
        template_id: id,
        locale: lang,
      })
      .then((result) => {
        if (result?.data && !result?.data?.link) {
          return;
        }
        resolve(result.data);
      })
      .catch((error) => {
        dispatch({
          type: LOADER,
          payload: true,
        });
        dispatch({
          type: SET_SNACKBAR_ERROR,
          payload: t('There_was_a_problem_of_creating_checkout_session__Please_try_again___'),
        });
      });
  });
};

export const purchaseSubscription = (id, lang) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(`/payments/stripe/subscription/create/`, {
        template_id: id,
        locale: lang,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        dispatch({
          type: SET_SNACKBAR_ERROR,
          payload: t('There_was_a_problem_of_creating_subscription__Please_try_again___'),
        });
      });
  });
};

export const addOnSubscription = (template_id, lang) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(`/payments/stripe/subscription/add-addon/`, {
        template_id: template_id,
        locale: lang,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        dispatch({
          type: SET_SNACKBAR_ERROR,
          payload: t('There_was_a_problem_of_creating_subscription__Please_try_again___'),
        });
      });
  });
};

export const getBillingDetails = () => (dispatch) => {
  trackPromise(
    axiosInstance
      .get('/payments/billing/summary/')
      .then((result) => {
        const { data } = result;
        let response = data;

        const region = getDeployRegion();
        if (region === GERMANY && !data.test_mode) {
          const usages = data?.subscription_usages || [];
          const usageBilling = usages.sort(
            (a, b) => new Date(b.subscription.start_date) - new Date(a.subscription.start_date)
          )[0];
          if (usageBilling) {
            response = {
              ...data,
              subscription_usages: [
                {
                  ...usageBilling,
                  subscription: {
                    ...usageBilling.subscription,
                    title: 'Pay_per_Scan',
                    subtitle: 'per_scan',
                  },
                },
              ],
              total_exam_balance: usageBilling?.current_period_usage,
            };
          }
        }

        dispatch({
          type: GET_BILLING_DETAILS,
          payload: region === GERMANY ? response : splitBillingDetails(response),
        });
      })
      .catch((error) => {
        dispatch({
          type: SET_SNACKBAR_ERROR,
          payload:
            error.response?.data?.errors?.[0]?.message ??
            t('There_was_a_problem_retrieving_your_billing_details__Please_refresh_the_page_to_try_again_'),
        });
      }),
    'billing-area'
  );
};

export const getBillingHistory = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get('/payments/billing/history/')
      .then((result) => {
        resolve(splitingBillingHistory(result.data));
      })
      .catch((error) => {
        dispatch({
          type: SET_SNACKBAR_ERROR,
          payload:
            error.response?.data?.errors?.[0]?.message ??
            t('There_was_a_problem_retrieving_your_billing_history__Please_refresh_the_page_to_try_again_'),
        });
      });
  });
};
